import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiDatingPhotoGeneratorConfig } from '@/data/landingConfig/landingAiDatingPhotoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiDatingPhotoGenerator } from './schemaObject';

interface Props {}
const AiDatingPhotoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiDatingPhotoGenerator} />
			<LandingTemplate
				data={landingAiDatingPhotoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiDatingPhotoGenerator;
